import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { sanitizeInvitationNoteHtml } from '../../utils/invitation-note.utils';

@Component({
  selector: 'app-rich-text-note-display',
  standalone: true,
  template: '<div class="prose prose-sm max-w-none" [innerHTML]="safeValue"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextNoteDisplayComponent implements OnChanges {
  @Input() value: string | null | undefined;
  safeValue = '';

  ngOnChanges(): void {
    this.safeValue = sanitizeInvitationNoteHtml(this.value || '');
  }
}
